import { useCallback } from 'react'
import { AxiosError } from 'axios'
import { useSnackbar, OptionsObject } from 'notistack'
import i18n from 'common/i18n'
import { HttpError } from 'lib/maasErrorBoundary'

type TErrorSnackbarOptions = OptionsObject & {
  fallbackMessage?: string
}

const defaultMessage = i18n.t('general.generalError')

function useApiErrorHandler() {
  const { enqueueSnackbar } = useSnackbar()

  const getMessageByError = (error?: AxiosError, fallbackMessage?: string) => {
    const httpErrorInstance = new HttpError(error)

    if (fallbackMessage) {
      return fallbackMessage
    }

    if (error) {
      const data = httpErrorInstance.response?.data
      return data?.detail?.message || data?.message || defaultMessage
    }

    return defaultMessage
  }

  const handleErrorSnackbar = useCallback(
    (error?: AxiosError, options?: TErrorSnackbarOptions) => {
      const { fallbackMessage, ...props } = options || {}
      const snackbarMessage = getMessageByError(error, fallbackMessage)

      enqueueSnackbar(snackbarMessage, { variant: 'error', ...props })
    },
    [enqueueSnackbar]
  )

  return {
    handleErrorSnackbar,
    getMessageByError,
  }
}

export default useApiErrorHandler
